import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import notification from 'ant-design-vue/es/notification'
import message from 'ant-design-vue/es/message'
import { VueAxios } from './axios'
import { ACCESS_TOKEN } from '@/store/mutation-types'

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL, // api base_url
  timeout: 3000000 // 请求超时时间
})

const err = (error) => {
  if (error.response) {
    const data = error.response.data
    const token = Vue.ls.get(ACCESS_TOKEN)
    if (error.response.status === 403) {
      notification.error({
        message: '请求错误',
        description: data.message
      })
    }
    if (error.response.status === 430) {
      message.error(data.message)
    }
    if (error.response.status === 401) {
      if (token) {
        store.dispatch('Logout').then(() => {
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        })
      }
    }
  }
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => {
  const token = Vue.ls.get(ACCESS_TOKEN)
  if (token) {
    config.headers['Authorization'] = "Bearer " + token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }else{
    config.headers['Authorization'] = "Basic Ym1zbmFidjg3Z2Y6OGMyOGIwZjEzODc5NDA1NjliOGU4ZDA5ZDFlZTcxYjU="
  }
  config.headers['locale'] = localStorage.lang
  config.headers['Content-Type'] = "application/json;chart;charset=UTF-8"
  return config
}, err)

// response interceptor
service.interceptors.response.use((response) => {
  let res = response.data
  if(res.code && res.code != 1){
    if(res.code < 50000){
      message.error(res.message)
    }

  }
  console.log("请求响应",response)
  if (response.request.responseType === 'blob' && response.request.responseURL.indexOf('watermarkDowLoadFileWord') > -1) {
    console.log("下载文件",response.headers['content-disposition'],{ data: res, fileName: decodeURIComponent(response.headers['content-disposition'].split('fileName=')[1]) })
    return { data: res, fileName: decodeURIComponent(response.headers['content-disposition'].split('fileName=')[1]) }
  }

  return res
}, err)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}
